// Auslöse-Signal für "Offene Punkte übernehmen" (#826).
//
// Eigenes, abhängigkeitsfreies Leaf-Modul — exakt aus demselben Grund wie
// store/deepLinks: die Auslöser sitzen in leichten Zeilen-Komponenten
// (RecordStepList, Detail-Ansicht), der Dialog dagegen hängt an Modal und damit
// an preact/compat. Läge das Signal im Dialog-Modul, zöge jeder Auslöser diesen
// schweren Teilbaum in seinen Modulgraphen — mit echten Nebenwirkungen:
// preact/compat verbiegt beim Laden global die onChange-Semantik von
// Formularelementen (React-Kompatibilität), was den Prioritäts-Select in
// RecordRow still auf ein anderes Event umhängt.
//
// Öffnen von irgendwo:  carryOverStepsSig.value = taskId;

import { signal } from "@preact/signals";

/** Id der Aufgabe, deren offene Punkte übernommen werden sollen (null = zu). */
export const carryOverStepsSig = signal<number | null>(null);
